<script setup lang="ts">
/**
 * Верхняя панель экрана — макет 34:249: высота 48, крошки слева с отступом 20,
 * действия справа. Наполнение у каждого экрана своё (10 контекстов в макете),
 * поэтому здесь только каркас со слотами.
 */
defineProps<{
  /** Крошки: последняя — текущий экран, её не делаем ссылкой */
  breadcrumbs?: { label: string; to?: string; mono?: boolean }[]
}>()
</script>

<template>
  <header class="toolbar">
    <!-- Перед крошками: кнопка «назад» на странице задачи (макет 13:401) -->
    <slot name="lead" />

    <nav v-if="breadcrumbs?.length" class="toolbar__breadcrumbs">
      <template v-for="(crumb, index) in breadcrumbs" :key="crumb.label">
        <span v-if="index > 0" class="toolbar__separator">/</span>
        <RouterLink v-if="crumb.to" class="toolbar__crumb" :to="crumb.to">
          {{ crumb.label }}
        </RouterLink>
        <span
          v-else
          class="toolbar__crumb toolbar__crumb--current"
          :class="{ 'toolbar__crumb--mono': crumb.mono }"
        >
          {{ crumb.label }}
        </span>
      </template>
    </nav>

    <slot name="breadcrumbs" />

    <div class="toolbar__actions">
      <slot />
    </div>
  </header>
</template>

<style scoped>
.toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  height: 48px;
  padding: 0 20px;
  border-bottom: 1px solid var(--color-border);
  /* Панель белая, а страница под ней серая (--color-bg-app): в макете они
     различаются, и серая панель на серой странице теряет границу экрана. */
  background-color: var(--color-surface);
}

.toolbar__breadcrumbs {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--font-size-body);
}

.toolbar__crumb {
  color: var(--color-text-muted);
  text-decoration: none;
}

.toolbar__crumb:hover {
  color: var(--color-text-primary);
}

.toolbar__crumb--current {
  color: var(--color-text-primary);
  font-weight: 500;
}

/* Ключ задачи рядом с обычным текстом крошек — моноширинный, иначе
   «DEV-1421» читается как слово (макет 13:401). */
.toolbar__crumb--mono {
  font-family: var(--font-family-mono);
  font-size: var(--font-size-body-sm);
}

.toolbar__separator {
  color: var(--color-text-muted);
}

/* Телефон: путь целиком не влезает и рвёт шапку на две строки — оставляем
   только текущий экран (макет 28:61). */
@media (max-width: 768px) {
  .toolbar {
    padding: 0 12px;
  }

  .toolbar__crumb:not(.toolbar__crumb--current),
  .toolbar__separator {
    display: none;
  }
}

.toolbar__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}
</style>
